import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import styles from '../styles/Modal.module.css';

const Modal = ({ 
    isOpen, 
    onClose, 
    children, 
    title,
    className,
    showCloseButton = true,
    position = 'center'
}) => {
    const [showModal, setShowModal] = useState(false);
    const [animating, setAnimating] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setShowModal(true);
            setTimeout(() => setAnimating(true), 10);
        } else if (showModal) {
            setAnimating(false);
            setTimeout(() => setShowModal(false), 300);
        }
    }, [isOpen, showModal]);

    if (!showModal) return null;

    return ReactDOM.createPortal(
        <div className={`${styles.modal} ${animating ? styles.modalEnterActive : styles.modalHidden} ${className}`} >
            <div onClick={onClose} className={styles.modalOverlay}></div>
            <div className={styles.modalContent} style={{ alignItems: position }} onClick={e => e.stopPropagation()}>
                {/* <div className={styles.modalHeader}>
                    <h2>{title}</h2>
                    {showCloseButton && (
                        <button className={styles.closeButton} onClick={onClose}>
                            ✖
                        </button>
                    )}
                </div> */}
                <div className={styles.modalBody}>
                    {children}
                </div>
                <div className={styles.modalFooter}>
                    {showCloseButton && (
                        <button className={styles.closeButton} onClick={onClose}>
                            Fermer
                        </button>
                    )}
                </div>
            </div>
        </div>,
        document.body
    );
};

export default Modal;